// extracted by mini-css-extract-plugin
module.exports = {"profileIcon":"profileIcon_profileIcon__j5lvz","imageSrc":"profileIcon_imageSrc__3UpUi"};